import React from 'react';
import { motion } from 'framer-motion';
const particles = Array.from({
  length: 14
}, (_, i) => ({
  id: i,
  left: `${(i * 7 + 5) % 100}%`,
  size: 2 + i % 4,
  delay: i % 7 * 0.4,
  duration: 6 + i % 5,
  drift: (i % 2 === 0 ? 1 : -1) * (10 + i % 3 * 8)
}));
export function Preloader({
  onComplete
}: {
  onComplete: () => void;
}) {
  return <motion.div className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-black text-white overflow-hidden" initial={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 1,
    ease: 'easeInOut'
  }} data-id="element-64" data-mp="fc71irpnxeb3">
      {/* Subtle underwater light + atmosphere */}
      <div className="pointer-events-none absolute inset-0" data-id="element-65" data-mp="k3fe1wmahfsh">
        <motion.div className="absolute -top-1/4 left-1/2 h-[60vh] w-[60vh] -translate-x-1/2 rounded-full bg-blue-900/20 blur-[120px]" animate={{
        opacity: [0.15, 0.35, 0.15],
        scale: [1, 1.08, 1]
      }} transition={{
        duration: 6,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-66" data-mp="y1wxvj92q854" />
        <div className="absolute inset-0 bg-gradient-to-b from-black via-black to-blue-950/10" data-id="element-67" data-mp="1vpaq277m21vq" />
      </div>

      {/* Soft floating particles */}
      <div className="pointer-events-none absolute inset-0" data-id="element-68" data-mp="20poz9sky7hvc">
        {particles.map(p => <motion.span key={p.id} className="absolute bottom-[-10px] rounded-full bg-white/40 blur-[1px]" style={{
        left: p.left,
        width: p.size,
        height: p.size
      }} animate={{
        y: ['0vh', '-110vh'],
        x: [0, p.drift, 0],
        opacity: [0, 0.6, 0]
      }} transition={{
        duration: p.duration,
        delay: p.delay,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-69" data-mp="25mp6w7xg4sok" />)}
      </div>

      {/* Centered content */}
      <div className="relative z-10 flex flex-col items-center px-6 text-center" data-id="element-70" data-mp="23mb1q8haff9f">
        <motion.h1 className="font-heading text-2xl md:text-4xl font-medium uppercase tracking-[0.2em] text-white" initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} data-id="element-71" data-mp="1yngb4kd2wmer">
          Buceo y Navegación
        </motion.h1>

        <motion.p className="mt-5 font-mono text-[10px] md:text-xs uppercase tracking-[0.4em] text-white/50 font-light" initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.4,
        ease: 'easeOut'
      }} data-id="element-72" data-mp="2wd1ih3lykpz3">
          Exploramos el mundo bajo el agua
        </motion.p>

        {/* Thin animated progress line */}
        <div className="mt-12 h-px w-48 md:w-64 overflow-hidden bg-white/10" data-id="element-73" data-mp="3dn5dq03stm92">
          <motion.div className="h-full bg-white/80" initial={{
          width: '0%'
        }} animate={{
          width: '100%'
        }} transition={{
          duration: 1.8,
          ease: [0.65, 0, 0.35, 1]
        }} onAnimationComplete={onComplete} data-id="element-74" data-mp="2yxr3yqwb92t5" />
        </div>
      </div>
    </motion.div>;
}